import React from 'react';
import { AppComponent } from 'utils/components';

export default function FormChangePassword(props: { component: AppComponent }) {
	console.warn('unimplemented', props.component);

	return <div>form change pwd</div>;
}
